import { QueryClient } from '@tanstack/react-query';

// Kept out of App.tsx so importing it doesn't pull in the router and every page.
export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      refetchOnMount: false,
      refetchOnReconnect: false,
      retry: false,
      enabled: false,
      cacheTime: 0,
    },
  },
});
